import axios, { AxiosResponse } from 'axios'
import { message } from 'ant-design-vue'
import { ACCESS_TOKEN, USER_INFO } from '@/store/mutation-types'
import { baseURL } from '@/utils/util'
import ls from '@/utils/Storage'
import { globalLoading } from '@/store/reactiveState'
import emitter from '@/utils/eventBus'

const ContentType = {
  urlencoded: 'application/x-www-form-urlencoded;charset=UTF-8',
  json: 'application/json',
  formData: 'multipart/form-data'
}

// 创建 axios 实例   withCredentials: true,
const baseService = axios.create({
  // baseURL,
  timeout: 60000,
  responseType: 'json',
  headers: {'X-Requested-With': 'XMLHttpRequest'}
})
const AuthorizationType={
  bearer:'Bearer',
}

// request interceptor
baseService.interceptors.request.use(
  (config) => {
    globalLoading.value = true
    const token = ls.get(ACCESS_TOKEN)
    if (token) {
      config.headers.Authorization=AuthorizationType.bearer+" "+token
      config.headers['TOKEN'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    config.headers['Content-Type'] = ContentType.json //'ContentType[config.data instanceof FormData ? 'formData' : 'json']
    return config
  },
  (error) => {
    globalLoading.value = false
    return Promise.reject(error)
  }
)

baseService.interceptors.response.use(
  (res: AxiosResponse<any>) => {
    globalLoading.value = false
    if (res.status === 200) {
      if(res.data.state<5){
        if(res.data.message){ message.error(res.data.message)}
         return res.data
      } else{
         emitter.emit('axios_goto_login')
      }
    }
  },
  (error) => {
    globalLoading.value = false
    const msg = error.message
    const result = error.response
    if (result) {
      const { data, status } = result
        message.error(status+" : "+data.message)
    } else if (msg) {
      message.error(msg)
    } else {
      message.error('未知错误,请重试!')
    }
    return false
  }
)

export default baseService
